import { Gates } from 'shared/typings/user/User'

import { RootState } from 'typesafe-actions'

import { getCurrentUser } from '../user/selectors'

export const getGates = (state: RootState): Gates => {
  const user = getCurrentUser(state)
  return (
    (user && user.gates) || {
      has_message_convo_channel: false,
      standard_trial: false,
      premium_team: false,
      premium_drift: false,
      premium_enterprise: false,
      service_agent_view: false,
    }
  )
}

// a user is on the free plan if they don't have the pro plan, the starter plan, the company plan, or the standard trial
export const isOnFreePlan = (state: RootState): boolean => {
  return (
    !getGates(state).standard_trial &&
    !getGates(state).premium_team &&
    !getGates(state).premium_drift &&
    !getGates(state).premium_enterprise
  )
}

export const getCurrentPlan = (state: RootState): string => {
  if (getGates(state).premium_enterprise) {
    return 'premium+'
  }

  if (getGates(state).premium_team) {
    return 'pro'
  }

  if (getGates(state).premium_drift) {
    return 'standard'
  }

  return 'free'
}

export const getHasPushCluster = (): boolean => false

export const hasDriftIntel = (state: RootState): boolean =>
  getGates(state).premium_enterprise || getGates(state).premium_team || false

export const hasDemoOrg = (state: RootState): boolean => !!getGates(state).has_slack_demo_org

export const hasAccountActivityView = (state: RootState): boolean =>
  !!getGates(state).has_account_activity

export const hasDriftSMS = (state: RootState): boolean => !!getGates(state).has_drift_sms

export const hasMoveAndLeave = (state: RootState): boolean =>
  !!getGates(state).has_conversation_move

export const hasPendingChats = (state: RootState): boolean => !!getGates(state).has_pending_chats

export const hasPermaclose = (state: RootState): boolean =>
  !!getGates(state).has_permaclose_conversation

export const hasSalesforceOpportunities = (state: RootState): boolean =>
  !!getGates(state).has_convo_salesforce_opportunities || hasSalesforceOpportunitiesV2(state)

export const hasSalesforceOpportunitiesV2 = (state: RootState): boolean =>
  !!getGates(state).has_convo_salesforce_opportunities_v2

export const hasUnifiedNavInDesktop = (state: RootState): boolean =>
  !!getGates(state).unified_nav_in_desktop

export const hasUserSubscriptionAllConvosSection = (state: RootState): boolean =>
  !!getGates(state).has_user_subscription_all_convos_section

export const hasUserSubscriptionAllSections = (state: RootState): boolean =>
  !!getGates(state).has_user_subscription_all_sections

export const hasConversationResponseTimer = (state: RootState): boolean =>
  !!getGates(state).has_convo_response_timer

export const hasServiceAgentView = (state: RootState): boolean =>
  !!getGates(state).service_agent_view

export const hasLogRocket = (state: RootState): boolean => !!getGates(state).has_logrocket
